import React from "react"
import { Link } from "gatsby"

export const AuthorBox = () => (
  <section className="text-gray-700 body-font">
    <div className="container mx-auto px-5 py-10">
      <div className="max-w-3xl border-t border-gray-200 pt-8">
        <p className="text-sm uppercase tracking-wider text-purple-500 mb-2">
          Sobre a autora
        </p>
        <h3 className="title-font text-xl font-medium text-gray-900 mb-3">
          Gabriela Muttoni
        </h3>
        <p className="text-gray-700 leading-relaxed">
          Terapeuta integrativa em Porto Alegre. Mestre Reiki na linhagem Usui,
          taróloga (Tarô Alquímico), terapeuta floral Alkhemy Lab e praticante
          de Barras de Access Consciousness. Atende presencialmente em Porto
          Alegre e online para todo o Brasil.{" "}
          <Link to="/" className="text-purple-600 hover:underline">
            Conheça meu trabalho
          </Link>
          .
        </p>
      </div>
    </div>
  </section>
)
